import { customAlphabet } from "nanoid";

// Alphanumeric alphabet (0-9, A-Z, a-z) - 62 characters
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

// Create generator for 10-character IDs
const nanoid = customAlphabet(alphabet, 10);

/**
 * Generate a unique 10-character alphanumeric ID for blocks.
 * Uses nanoid with a custom alphabet for URL-safe, collision-resistant IDs.
 */
export function generateBlockId(): string {
  return nanoid();
}

/**
 * Generate a unique 10-character alphanumeric ID for items within blocks.
 * Uses the same generator as generateBlockId for consistency.
 * Separate function for semantic clarity and future flexibility.
 */
export function generateItemId(): string {
  return nanoid();
}
